import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  key: 'datacube',
  storage: window.localStorage,
});

export default new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: {
    hasAccess: false,
    user: {},
    globalLoading: false,
    snackbar: {},
  },
  mutations: {
    setAccess(state, value) {
      state.hasAccess = value;
    },
    setLayout(state, value) {
      state.layout = value;
    },
    setUser(state, value) {
      state.user = value;
    },
    setUserLang(state, value) {
      if (!state.user.preferences) {
        state.user.preferences = {};
      }
      state.user.preferences.language = value;
    },
    setUserTheme(state, value) {
      if (!state.user.preferences) {
        state.user.preferences = {};
      }
      state.user.preferences.darkTheme = value;
    },
    setGlobalLoading(state, value) {
      state.globalLoading = value;
    },
    setSnackbar(state, value) {
      state.snackbar = value;
    },
    logout(state) {
      state.user = {};
      state.hasAccess = false;
    },
  },
  actions: {
    setAccess(context, value) {
      context.commit('setAccess', value);
    },
    setLayout(context, value) {
      context.commit('setLayout', value);
    },
    setUser(context, value) {
      context.commit('setUser', value);
    },
    setUserLang(context, value) {
      context.commit('setUserLang', value);
    },
    setUserTheme(context, value) {
      context.commit('setUserTheme', value);
    },
    setGlobalLoading(context, value) {
      context.commit('setGlobalLoading', value);
    },
    setSnackbar(context, value) {
      context.commit('setSnackbar', value);
    },
    logout(context) {
      context.commit('logout');
    },
  },
});
